import React from 'react';

const PedidosLoading = ({ count = 3 }) => {
  const items = Array.from({ length: count });

  return (
    <>
      {items.map((_, idx) => (
        <div className="itemPedido loading" key={idx} aria-busy="true" aria-live="polite">
          <div className="tab">
            <div>
              <div className="order-identifier">
                <div className="icon-UserStar skeleton-block" />
                <span className="identifier-text skeleton-line" />
              </div>
            </div>
            <div>
              <div>
                <button className="btn skeleton-button" disabled />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default PedidosLoading;
